import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01cd219e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "discount" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "¿Tienes un código descuento?", -1))
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 0,
  class: "promo-code"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PromoCode = _resolveComponent("PromoCode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["top", { opened: _ctx.opened }])
    }, [
      _hoisted_2,
      _createElementVNode("a", {
        href: "#",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.opened = _ctx.appliedDiscount || !_ctx.opened), ["prevent"]))
      }, [
        _createElementVNode("img", {
          src: require('@/assets/images/chevron.svg'),
          alt: _ctx.opened? 'desplegado' : 'oculto' 
        }, null, 8, _hoisted_3)
      ])
    ], 2),
    (_ctx.opened)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_PromoCode, {
            modelValue: _ctx.modelValue,
            applied: _ctx.appliedDiscount,
            error: _ctx.error,
            onApply: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('apply', _ctx.modelValue))),
            onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', _ctx.throwEvent($event.target))))
          }, null, 8, ["modelValue", "applied", "error"])
        ]))
      : _createCommentVNode("", true)
  ]))
}